import { TextInput, TextInputProps, Tooltip } from '@mantine/core';
import { IconQrcode } from '@tabler/icons-react';
import ActionIcon from 'components/ActionIcon';
import { useDeviceQrPairingModal } from 'components/modals/device-qr-pairing/DeviceQrPairingModalProvider';

export interface DeviceQrIdInputProps extends Omit<TextInputProps, 'rightSection'> {
  deviceName: string;
  onQrIdScanned: (qrId: string) => void;
}

/** Text input that can fill its value from the shared camera or image QR scanner. */
export default function DeviceQrIdInput({
  deviceName,
  onQrIdScanned,
  disabled,
  readOnly,
  ...props
}: DeviceQrIdInputProps) {
  const { openDeviceQrPairingModal } = useDeviceQrPairingModal();
  const scanDisabled = Boolean(disabled || readOnly);

  return (
    <TextInput
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      rightSectionWidth={52}
      styles={{ rightSection: { pointerEvents: 'auto' } }}
      rightSection={
        <Tooltip label="Naskenovať QR kód">
          <ActionIcon
            type="button"
            variant="subtle-gray"
            size="sm"
            aria-label="Naskenovať QR kód"
            disabled={scanDisabled}
            onClick={() =>
              openDeviceQrPairingModal({
                mode: 'select',
                deviceName: deviceName || 'nové zariadenie',
                onSelected: onQrIdScanned,
              })
            }
          >
            <IconQrcode stroke={1.5} size={20} />
          </ActionIcon>
        </Tooltip>
      }
    />
  );
}
